export default "__VITE_ASSET__B$pIxhBH__"